module.exports = __webpack_public_path__ + "img/identityCR.f3ee018c.png";